import { saveGSTR3BToPortal } from '../../../services/gst/portalService'

export const ActionTypes = {
  SAVE_GSTR3B_TO_PORTAL: 'SAVE_GSTR3B_TO_PORTAL',
}

export const saveGSTR3BToPortalAction = (retPeriod: string, gstr3bJson: Record<string, any>) => ({
  type: ActionTypes.SAVE_GSTR3B_TO_PORTAL,
  promise: saveGSTR3BToPortal(retPeriod, gstr3bJson),
})

export const saveGSTR3BToPortalResetAction = () => ({
  type: `${ActionTypes.SAVE_GSTR3B_TO_PORTAL}_RESET`,
})

interface SaveGSTR3BState {
  loading: boolean
  success: boolean
  error: string | null
  message: string | null
  errorCode: string | null
}

const initialState: SaveGSTR3BState = {
  loading: false,
  success: false,
  error: null,
  message: null,
  errorCode: null,
}

export const saveGSTR3B = (
  state: SaveGSTR3BState = initialState,
  action: { type: string; res: any }
): SaveGSTR3BState => {
  switch (action.type) {
    case `${ActionTypes.SAVE_GSTR3B_TO_PORTAL}_REQUEST`:
      return { ...initialState, loading: true }

    case `${ActionTypes.SAVE_GSTR3B_TO_PORTAL}_SUCCESS`:
      return {
        ...state,
        loading: false,
        success: action.res?.success ?? false,
        message: action.res?.message ?? null,
        errorCode: action.res?.code ?? action.res?.errorCode ?? null,
      }

    case `${ActionTypes.SAVE_GSTR3B_TO_PORTAL}_FAILURE`:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.res?.message ?? 'Failed to save GSTR3B',
        message: action.res?.message ?? 'Failed to save GSTR3B',
        errorCode: action.res?.code ?? action.res?.errorCode ?? null,
      }

    case `${ActionTypes.SAVE_GSTR3B_TO_PORTAL}_RESET`:
      return { ...initialState }

    default:
      return state
  }
}
